import { saveOptions } from '../Firebase/apiPrintOptions'

const PRINT_OPTIONS_RECEIVE = 'PRINT_OPTIONS_RECEIVE'
const PRINT_OPTIONS_CHANGE = 'PRINT_OPTIONS_CHANGE'

export const getOptionsKey = (projectId, view) => `${projectId}_${view}`

export const printOptionsReceive = options => {
  return {
    type: PRINT_OPTIONS_RECEIVE,
    options: options
  }
}

export const printOptionsChanged = (projectId, view, options) => {
  return (dispatch, getState) => {
    const temp_stored = getState().printOptions
    const key = getOptionsKey(projectId, view)
    const stored = temp_stored && temp_stored[key] ? temp_stored[key] : null
    let hasChanges = false
    if (stored) {
      for(let p in stored){
        if (options[p] !== stored[p]) {
          hasChanges = true
          break
        }
      }
    }
    if (!stored || hasChanges) {
      saveOptions(key, options)
    }
    dispatch(printOptionsChanged2(key, options))
  }
}

const printOptionsChanged2 = (key, options) => {
  return {
    type: PRINT_OPTIONS_CHANGE,
    key: key,
    options: options
  }
}

const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case PRINT_OPTIONS_RECEIVE:
      return action.options
    case PRINT_OPTIONS_CHANGE:
      return {
        ...state,
        [action.key]: {
          ...action.options
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/printOptions.js